import curry2 from '../curry2';

const split = curry2(_split);
export default split;

function _split(delim: string, str: string): string[] {
  return str.split(delim);
}
